import type { ReactNode } from "react";
import { Box, Grid, Typography } from "@mui/material";

export type MonthGroup<T> = {
  month: string;
  items: T[];
};

export type MonthGroupedGridProps<T> = {
  groups: MonthGroup<T>[];
  getKey: (item: T) => string;
  renderItem: (item: T) => ReactNode;
};

export const MonthGroupedGrid = <T,>({
  groups,
  getKey,
  renderItem,
}: MonthGroupedGridProps<T>) => (
  <Box>
    {groups.map((group) => (
      <Box key={group.month} sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
          {group.month}
        </Typography>
        <Grid container spacing={2}>
          {group.items.map((item) => (
            <Grid key={getKey(item)} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              {renderItem(item)}
            </Grid>
          ))}
        </Grid>
      </Box>
    ))}
  </Box>
);
